/**
 * 定义计算KDJ指标类
 */
class KDJ {
    /**
     * 计算KDJ指标
     * @param {Array<Number>} closes 收盘价
     * @param {Array<Number>} lowests 最低价
     * @param {Array<Number>} highests 最高价
     */
    constructor(closes = [], lowests = [], highests = []) {
        this.closes = closes;
        this.lowests = lowests;
        this.highests = highests;
        this.ks = [];
        this.ds = [];
        this.js = [];

        this.seriesOptions = [];
        ['K', 'D', 'J'].forEach(key => {
            this.seriesOptions.push(key = {
                name: key,
                type: 'line',
                data: [],
                xAxisIndex: 3,
                yAxisIndex: 3,
                showSymbol: false,
                lineStyle: {
                    width: 1
                }
            });
        });
    }

    /**
     * 按照指定天数计算KDJ指标
     * @param {Number} dayCount 要计算几天的指标
     * @param {Number} multiple 倍数
     */
    calculate(dayCount = 9, multiple = 3) {
        this.ks = [];
        this.ds = [];
        this.js = [];
        for (let index = 0; index < this.closes.length; index++) {
            if (index === 0 || index < dayCount - 1) {
                this.ks[index] = this.ds[index] = 50;
                this.js[index] = 0;
                continue;
            }

            let close = this.closes[index];
            let intervalHighests = this.highests.slice(index - dayCount + 1, index + 1);
            let intervalLowest = this.lowests.slice(index - dayCount + 1, index + 1);
            let maxClose = Math.max(...intervalHighests);
            let minClose = Math.min(...intervalLowest);
            let rsv = 0;
            if (maxClose !== close) {
                rsv = (close - minClose) / (maxClose - minClose);
            }
            rsv *= 100;
            let lastIndex = Math.max(index - 1, 0);
            let k = (2 * this.ks[lastIndex] + rsv) / multiple;
            let d = (2 * this.ds[lastIndex] + k) / multiple;
            let j = multiple * k - 2 * d;
            this.ks[index] = k;
            this.ds[index] = d;
            this.js[index] = j;
        }
    }

    /**
     * 生成Series选项
     * @returns {Object} 返回生成的echarts的option对象
     */
    generateSeriesOption() {
        this.seriesOptions.forEach(option => {
            let key = option.name.toLowerCase() + 's';
            option.data = this[key];
        });
        return this.seriesOptions;
    }
}

export default KDJ;



// WEBPACK FOOTER //
// ./src/controller/series/KDJ.js